<template>
    <div class="banner_wrapper" :style="backgroundImageInlineStyle">
        <div class="movie-info">
            <div class="free-badge">
                <span class="free-badge-icon">✦</span> {{ $t('banner.free') }}
            </div>
            <h1 class="movie-info_title">{{ banner.title }}</h1>
            <p>{{ this.discription }}</p>
            <div class="btn-group">
                <my-button class="btn btn-watch" @click="$router.push(`/movie/${banner.id}`)">
                    ▶ {{ $t('banner.watchNow') }}
                </my-button>
                <my-button class="btn btn-more" @click="$router.push(`/movie/${banner.id}`)">
                    {{ $t('banner.viewMore') }}
                </my-button>
            </div>
        </div>
    </div>
</template>

<script>
import getImage from '@/lib/getImage';
import MyButton from '@/components/UI/myButton.vue';

export default {
    components: {
        MyButton
    },
    props: {
        banner: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            bgImage: '',
            discription: ''
        }
    },
    computed: {
        backgroundImageInlineStyle() {
            return `background-image: url(${this.bgImage})`
        },
    },
    watch: {
        banner() {
            this.bgImage = getImage(this.banner.backdrop_path)
            this.discription = this.banner.overview.length <= 200 ? this.banner.overview : this.banner.overview.slice(0, 200) + "..."
        }
    }
}
</script>

<style scoped>
.banner_wrapper {
    width: 100%;
    height: 100vh;
    background-size: cover;
}

.movie-info {
    color: aliceblue;
    width: 60%;
    padding-left: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    background: linear-gradient(to right, black, transparent);
}

.free-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgb(34 197 94 / 0.15);
    border: 1px solid rgb(34 197 94 / 0.5);
    color: rgb(34 197 94);
    font-size: 13px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 20px;
    width: fit-content;
    margin-bottom: 14px;
    letter-spacing: 0.03em;
}

.free-badge-icon {
    font-size: 10px;
}

.movie-info_title {
    font-size: 3rem;
    font-weight: bold;
}

.movie-info p {
    width: 50%;
    margin-top: 20px;
}

.btn-group {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 20px;
}

.btn-watch {
    margin-top: 0 !important;
    background-color: rgb(34 197 94) !important;
    color: #000 !important;
    font-size: 16px !important;
}

.btn-watch:hover {
    background-color: rgb(22 163 74) !important;
}

.btn-more {
    margin-top: 0 !important;
    background-color: rgba(255,255,255,0.15) !important;
    backdrop-filter: blur(4px);
}


@media only screen and (max-device-width: 480px) {
    .banner_wrapper {
        width: 100%;
        height: 100vh;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }

    .movie-info {
        padding-left: 50px;
    }

    .movie-info_title {
        font-size: large;
    }

    .movie-info p {
        display: none;
    }

    .btn-group {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .movie-info .btn {
        padding: 15px 10px;
    }
}

@media only screen and (max-width: 810px) {
    .banner_wrapper {
        width: 100%;
        height: 600px;
        background-size: 80% 80% cover;
        background-position: center;
    }

    .movie-info {
        padding-left: 50px;
    }
}
</style>